import { render, staticRenderFns } from "./TrainingCopyTreeItem.vue?vue&type=template&id=4a234363&scoped=true&"
import script from "./TrainingCopyTreeItem.vue?vue&type=script&lang=js&"
export * from "./TrainingCopyTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCopyTreeItem.vue?vue&type=style&index=0&id=4a234363&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a234363",
  null
  
)

export default component.exports